import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String], $for_admin: Int) {
        shop(ids: $ids, for_admin: $for_admin) {
          data {
            lat
            lng
            alias
            title
            address
            is_active
          }
        }
      }
    `,
  },
  update: {
    name: 'updateShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateShop(
        $ids: [String]!
        $lat: String
        $lng: String
        $alias: String
        $title: String
        $address: String
        $is_active: Int
      ) {
        updateShop(
          ids: $ids
          lat: $lat
          lng: $lng
          alias: $alias
          title: $title
          address: $address
          is_active: $is_active
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
